import { Divider } from 'antd'
import { isArray, isBoolean, isElement, isEmpty } from 'lodash'
import dayjs from 'dayjs'
import { replaceRule } from '@/utils/data'

// 通项选材
export const config = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 80,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '通项/分类',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '是否必选',
      name: 'requiredFlag',
      dataIndex: 'requiredFlag',
      width: 100,
      render: 'isRequiredRender',
    },
    {
      title: '产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '是否标配',
      dataIndex: 'standardFlag',
      width: 150,
      name: 'standardFlag',
      render: (text: any, record: any) => renderListFn(record, 'standardFlag'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 90,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 100,
      fixed: 'right',
      render: 'actionRender',
    },
  ],
  searchMode: 'group',
  // "search": false,
  footer: [
    {
      label: '差异化清单',
      name: 'openDifferentiationList',
      render: 'renderOpenDifferentiationList',
    },
    {
      label: '新增选材',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 项目选材
export const projectConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 80,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '产品分类',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 90,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
  ],
  searchMode: 'group',
  // "search": false,
  footer: [
    {
      label: '差异化清单',
      name: 'openDifferentiationList',
      render: 'renderOpenDifferentiationList',
    },
    {
      label: '新增选材',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 增项选材
export const addConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 100,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '类型',
      dataIndex: 'sourceType',
      width: 100,
      render: (text: any, record: any) => {
        return <span>{record.sourceType === 'PRODUCT' ? '产品' : '通项'}</span>
      },
    },
    {
      title: '产品分类',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 90,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 100,
      fixed: 'right',
      render: 'actionRender',
    },
  ],
  searchMode: 'group',
  // "search": false,
  footer: [
    {
      label: '新增增项',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 减项选材
export const subConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 100,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '所在位置',
      dataIndex: 'spaceName',
      width: 100,
    },
    {
      title: '类型',
      dataIndex: 'prdCateName',
      width: 100,
      render: (text: any, record: any) => {
        return <span> {record?.generalItemManageId ? '通项' : '产品'}</span>
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      width: 280,
      name: 'name',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 200,
      render: (text: any, record: any) => {
        if (record?.dynaOptions && Object.keys(record?.dynaOptions).length) {
          const strings: string[] = []
          for (let key in record.dynaOptions) {
            strings.push(
              `${record.dynaOptions[key]?.argName}：${record.dynaOptions[key]?.valueName}`
            )
          }
          return strings.map((str: string) => <div key={str}>{str}</div>)
        } else {
          return <span></span>
        }
      },
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => {
        return <span> {text ? text : '-'}</span>
      },
    },
    {
      title: '单价',
      dataIndex: 'displayCustPrice',
      width: 120,
      name: 'displayCustPrice',
      align: 'left',
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 120,
      name: 'budgetAmount',
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 100,
      fixed: 'right',
      render: 'actionRender',
    },
  ],
  searchMode: 'group',
  // "search": false,
  footer: [
    {
      label: '新增减项',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 活动选材
export const disconutConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 100,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '活动名称',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '赠送产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 120,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
  ],
  searchMode: 'group',
  footer: [
    {
      label: '新增优惠',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 升降级选材
export const uporDownConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 80,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '通项',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '预算量计算式',
      dataIndex: 'displayQtyFormular',
      name: 'displayQtyFormular',
      width: 160,
      render: (text: any, record: any) => renderListFn(record, 'displayQtyFormular'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 120,
      name: 'displayQtyValue',
      render: (text: any, record: any) => renderListFn(record, 'displayQtyValue'),
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 120,
      name: 'budgetAmount',
      render: (text: any, record: any) => renderListFn(record, 'budgetAmount'),
    },
    {
      title: '所在位置',
      dataIndex: 'spaceName',
      width: 100,
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '选择日期',
      dataIndex: 'createdTime',
      name: 'createdTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'createdTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 100,
      fixed: 'right',
      render: 'actionRender',
    },
  ],
  searchMode: 'group',
  // "search": false,
  footer: [
    {
      label: '新增升降级',
      name: 'add',
      type: '',
      events: ['onClick:onAdd'],
    },
  ],
}
// 缺断货选材
export const shortageConfig = {
  rowSelection: false,
  sticky: {
    top: -10,
  },
  columns: [
    {
      title: '序号',
      dataIndex: 'orderSeq',
      width: 100,
      name: 'orderSeq',
      align: 'center',
      //   fixed: 'left',
      render: 'renderOrderSeq',
    },
    {
      title: '类型',
      dataIndex: 'sourceRefType',
      width: 100,
      // render: 'typeRender',
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'sourceRefType')
      },
    },
    {
      title: '缺断货产品',
      dataIndex: 'materialRender',
      width: 400,
      name: 'materialRender',
      //   fixed: 'left',
      render: 'renderSku',
    },
    {
      title: '规格',
      dataIndex: 'dynaOptions',
      width: 150,
      name: 'dynaOptions',
      render: (text: any, record: any) => renderListFn(record, 'dynaOptions'),
    },
    {
      title: '单位',
      dataIndex: 'prdUnit',
      width: 90,
      name: 'prdUnit',
      render: (text: any, record: any) => renderListFn(record, 'prdUnit'),
    },
    {
      title: '单价',
      dataIndex: 'saleCustPrice',
      width: 120,
      name: 'saleCustPrice',
      align: 'left',
      render: (text: any, record: any) => renderListFn(record, 'saleCustPrice'),
    },
    {
      title: '添加位置',
      dataIndex: 'spaceName',
      width: 90,
      name: 'spaceName',
      render: (text: any, record: any) => renderListFn(record, 'spaceName'),
    },
    {
      title: '预算量',
      dataIndex: 'displayQtyValue',
      width: 90,
      name: 'displayQtyValue',
      // render:'displayQtyValueRender'
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'displayQtyValue')
      },
    },
    {
      title: '预算合价',
      dataIndex: 'budgetAmount',
      width: 90,
      name: 'budgetAmount',
      // render:'budgetAmountRender'
      render: (text: any, record: any) => {
        record.tableConfigType = 'shortageConfig'
        return renderListFn(record, 'budgetAmount')
      },
    },
    {
      title: '预计下架日期',
      dataIndex: 'outOfStockTime',
      name: 'outOfStockTime',
      width: 130,
      itemType: 'date',
      render: (text: any, record: any) => renderListFn(record, 'outOfStockTime', undefined, 'date'),
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 400,
      name: 'remark',
      render: (text: any, record: any) => renderListFn(record, 'remark'),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 100,
      fixed: 'right',
      render: 'handleRender',
    },
  ],
  searchMode: 'group',
  footer: [],
}
export const renderListFn = (
  record: any,
  dataIndex: string,
  nodeRenderFn?: any,
  itemType?: any
) => {
  const list = record?.budgetDtlVoList || []

  return !!list?.length ? (
    <div>
      {list.map((item, index) => {
        let text: any = item?.[dataIndex]
        if (!!text && itemType == 'dateTime') {
          text = dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!!text && itemType == 'date') {
          text = dayjs(text).format('YYYY-MM-DD')
        }
        if (dataIndex.includes('Flag')) {
          if (isBoolean(text)) {
            text = text ? '是' : '否'
          }
          text = text == '1' ? '是' : text == '0' ? '否' : text
        }
        if (dataIndex === 'dynaOptions') {
          if (text && Object.keys(text).length) {
            const strings: string[] = []
            for (let key in text) {
              strings.push(`${text[key].argName}：${text[key].valueName}`)
            }
            text = strings.map((str: string) => <div key={str}>{str}</div>)
          } else {
            text = <span></span>
          }
        }
        if (dataIndex === 'displayQtyFormular') {
          if (text) {
            text = replaceRule(text)
          }
        }

        // 缺断货选材单独处理
        if (
          record.tableConfigType === 'shortageConfig' &&
          (dataIndex === 'displayQtyValue' || dataIndex === 'budgetAmount')
        ) {
          text = text < 0 ? -1 * text : text
        }
        if (record.tableConfigType === 'shortageConfig' && dataIndex === 'sourceRefType') {
          let typeName = {
            ADD: '增项',
            ACTIVITY: '优惠',
            GENERAL: '通项选材',
            PROJECT: '项目选材',
            SUB: '减项',
            UP_DOWN: '升降级',
          }
          text = typeName[text] ? typeName[text] : '其他'
        }

        return (
          <div
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            {index != 0 && (
              <Divider
                style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
              />
            )}
            <div
              style={{
                minHeight: '76px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              {nodeRenderFn?.(item) || text}
            </div>
          </div>
        )
      })}
    </div>
  ) : (
    record[dataIndex]
  )
}
